import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [activeCenter, setActiveCenter] = useState("all");

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      // Don't clobber a user that a login already established (race guard)
      setUser((prev) => (prev && prev !== null ? prev : false));
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth callback, let AuthCallback handle it.
    if (window.location.hash?.includes("session_id=")) return;
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try {
      await api.post("/presence/checkout");
    } catch {}
    try {  // CRM attendance: sign-out stamps the day's end time so payroll hours are exact
      const t = localStorage.getItem("rcrm_token");
      if (t) await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/rcrm/attendance/logout`, {}, { headers: { Authorization: `Bearer ${t}` } });
    } catch {}
    try {
      await api.post("/auth/logout");
    } catch {}
    try {
      localStorage.removeItem("rcrm_token");
      localStorage.removeItem("rcrm_role");
      localStorage.removeItem("rcrm_uid");
    } catch {}
    setUser(false);
    window.location.href = "/login";
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, checkAuth, logout, activeCenter, setActiveCenter }}>
      {children}
    </AuthContext.Provider>
  );
}
